import React, { useState } from "react";
import "./PolicyRoadmap.css";

// 🎯 Statut => couleur de pastille
const getStatusClass = (status) => {
  switch (status) {
    case "Implemented": return "dot-green";
    case "Partially Implemented":
    case "Draft": return "dot-amber";
    case "Not Defined":
    default: return "dot-red";
  }
};

// 📚 Ordre logique ISO 27001 des domaines
const DOMAIN_ORDER = [
  "Governance",
  "Access Control",
  "Human Resources",
  "Asset Protection",
  "Development Security",
  "Cloud & Supply Chain",
  "Incident Management",
  "Business Continuity",
  "Compliance",
  "Uncategorized"
];

export default function PolicyRoadmap({ policies }) {
  const [openCards, setOpenCards] = useState({});

  // 🧠 Regroupement par domaine (clé = domain)
  const groupedByDomain = policies.reduce((acc, policy, idx) => {
    const domain = policy.domain || "Uncategorized";
    if (!acc[domain]) acc[domain] = [];
    acc[domain].push({ ...policy, _index: idx });
    return acc;
  }, {});

  const toggleCard = (index) => {
    setOpenCards(prev => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="roadmap-wrapper">
      {DOMAIN_ORDER
        .filter(domain => groupedByDomain[domain])
        .map(domain => {
          const items = groupedByDomain[domain];
          return (
            <div className="roadmap-domain-block" key={domain}>
              <h3 className="roadmap-domain-title">{domain}</h3>
              <div className="roadmap-cards">
                {items.map((p, i) => {
                  const key = `${domain}-${i}`;
                  const isOpen = openCards[key];

                  return (
                    <div
                      className={`roadmap-card ${isOpen ? "open" : ""}`}
                      key={key}
                      onClick={() => toggleCard(key)}
                    >
                      <div className="roadmap-card-header">
                        <span className={`status-dot ${getStatusClass(p.completion_status)}`}></span>
                        <span className="roadmap-clause">{p.clause}</span>
                      </div>

                      <div className="roadmap-policy-title">{p.policy}</div>

                      <div className={`roadmap-card-body ${isOpen ? "expanded" : ""}`}>
                        <p>{p.description}</p>
                        {p.iso_2013_clause && (
                          <div className="iso-legacy-ref">
                            ↳ <code>{p.iso_2013_clause}</code>: {p.iso_2013_description}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
    </div>
  );
}
